module.exports = __webpack_public_path__ + "img/ic_plus_sign_gray.0ed65f5c.svg";